export default "__VITE_ASSET__DtLlg4QG__"